module.exports = __webpack_public_path__ + "static/media/logo.d476ae43.png";